import { gql } from "@apollo/client";

export const QUERY_USER_METRICS_REPORT = gql`
  query (
      $districtIds: [ID], 
      $selectedFields: [String],
    ) {
    userMetricsReport(
      districtIds: $districtIds, 
      selectedFields: $selectedFields
    ) {
      success
      message
      reportDataJson
    }
  }
`;
